import $ from 'jquery';

function getFinalPos(el, menuItemLengths, menuItemHoverPos) {
    const position = Math.round($(el).position().left) + 2;
    let finalPos = null;
    menuItemLengths.some(function(item, index) {
        finalPos = menuItemHoverPos[index];
        return position < item;
    });
    return finalPos;
}

function getMenuPositions(scale = 1) {
    const menuItemLengths = [];
    const menuItemHoverPos = [];
    $('.js-menu li').each(function(i) {
        const previousItemLength = menuItemLengths[i - 1] || 0;
        menuItemLengths.push(Math.round(previousItemLength + $(this).width() * scale));
        menuItemHoverPos.push(previousItemLength + Math.round($(this).width() / 2));
    });

    return {menuItemLengths: menuItemLengths, menuItemHoverPos: menuItemHoverPos};
}

const MenuBlob = (el) => {
    let $el = $(el);

    const resizeScale = 0.8; // Same as transform scale in menu.scss
    const menuPositions = getMenuPositions();
    const menuItemHoverPos = menuPositions.menuItemHoverPos;
    let menuItemLengths = menuPositions.menuItemLengths;
    let  $currentItem = '';

    // Event triggered in sticky-header
    $('.header').on('headerSticky', function() {
        menuItemLengths = menuItemLengths.map((item) => Math.round(item * resizeScale));
    });

    // Event triggered in sticky-header
    $('.header').on('headerNotSticky', function() {
        menuItemLengths = menuPositions.menuItemLengths;
    });

    if ($('.menu__item--current').length) {
        $currentItem = '.menu__item--current';
    } else if ($('.menu__item--ancestor').length) {
        $currentItem = '.menu__item--ancestor';
    }

    if ($($currentItem).length) {
        const finalPos = getFinalPos($currentItem, menuItemLengths, menuItemHoverPos);
        $('.js-menu').css('--ball-position', finalPos + 'px');
    }

    $el.on('mousemove', function(event) {
        const position = Math.round(event.pageX - $(this).offset().left);
        let finalPos = menuItemHoverPos[0];
        menuItemLengths.some(function(item, index) {
            finalPos = menuItemHoverPos[index];
            return position < item;
        });
        $(this).css('--ball-position', finalPos + 'px');
    });

    $el.on('mouseout', function() {
        if ($($currentItem).length) {
            const finalPos = getFinalPos($currentItem, menuItemLengths, menuItemHoverPos);
            $('.js-menu').css('--ball-position', finalPos + 'px');
        }
    });
};

export default MenuBlob;
